import qs from 'qs'
import { axios } from '@/utils/request'

export const api = {
  page: '/api/1/bidXqdcFwf/page',
  getVoById: '/api/1/bidXqdcFwf/getVoById',
  getVoByXmId: '/api/1/bidXqdcFwf/getVoByXmId',
  addOrUpdateBidXqDcFwf: '/api/1/bidXqdcFwf/addOrUpdateBidXqDcFwf',
  updateBidXqdcFwf: '/api/1/bidXqdcFwf/updateBidXqdcFwf',
  delete: '/api/1/bidXqdcFwf/delete',
}
//需求调研接口
/**
 * 查询需求调研服务费项目
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryPage = (data) => axios.get(api.page, { params: { ...data }})
/**
 * 获取需求调研服务费项目
 * @param id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetVoById = (id) => axios.get(api.getVoById, { params: { id } })
/**
 * 获取需求调研服务费项目
 * @param xmId
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetVoByXmId = (xmId) => axios.get(api.getVoByXmId, { params: { xmId } })
/**
 * 删除需求调研服务费项目
 * @param id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const DeleteFee = (id) => axios.post(api.delete, qs.stringify({ id }))
/**
 * 添加或更新需求调研服务费项目
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AddOrUpdateBidXqDcFwf = (data) => axios.post(api.addOrUpdateBidXqDcFwf, data)
/**
 * 更新需求调研服务费项目
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const UpdateBidXqdcFwf = (data) => axios.post(api.updateBidXqdcFwf, data)
